var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0181 0.0739653C14.7532 -0.0783005 14.4145 0.0120649 14.2615 0.27579L12.5677 3.1976C11.4137 2.66703 10.2191 2.39575 9.00983 2.39575C5.76072 2.39575 2.61762 4.35543 0.0830284 8.03944L0.0729761 8.05392L0.0641838 8.06644C-0.0202418 8.18516 -0.0223969 8.32477 0.0637615 8.44214C1.93406 11.1708 4.13796 12.958 6.47197 13.7091L5.12263 16.035C4.96966 16.2987 5.06043 16.6359 5.32533 16.7882L5.56516 16.926C5.83006 17.0783 6.16878 16.988 6.32174 16.7242L15.4606 0.965038C15.6136 0.701314 15.5229 0.364094 15.2579 0.211822L15.0181 0.0739653ZM11.8329 4.46464C10.8937 4.05847 9.94528 3.8605 9.00983 3.8605C6.64906 3.8605 4.20519 5.12156 2.03475 7.8081C1.82639 8.06603 1.82639 8.442 2.03475 8.69993C3.6617 10.7138 5.44224 11.927 7.22631 12.4084L8.15919 10.7996C7.09352 10.4658 6.21231 9.53449 6.21231 8.25548C6.21231 6.63762 7.47478 5.32595 9.03185 5.32595C9.7506 5.32595 10.4066 5.60543 10.9046 6.06547L11.8329 4.46464ZM10.1347 7.39317C9.89488 7.02801 9.50061 6.79069 9.03185 6.79069C8.25265 6.79069 7.61539 7.44546 7.61539 8.25439C7.61539 8.78901 8.19914 9.41372 8.93243 9.46629L10.1347 7.39317Z",
    fill: "#2A86FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47559 14.1001C12.5521 13.9224 15.5113 11.9871 17.9211 8.49341C17.9716 8.42024 17.9998 8.34456 17.9998 8.25453C17.9998 8.16871 17.9755 8.09704 17.9275 8.02727C17.0014 6.68236 15.9938 5.56794 14.9295 4.69531L14.1962 5.95986C14.8073 6.47673 15.4058 7.09193 15.9847 7.80858C16.1931 8.06651 16.1931 8.44248 15.9847 8.7004C14.2389 10.8615 12.3161 12.1006 10.402 12.5027L9.47559 14.1001Z",
    fill: "#2A86FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenIcon);
export default __webpack_public_path__ + "static/media/HiddenIcon.e2119092ba0bab4acea6ec530c7c1619.svg";
export { ForwardRef as ReactComponent };